const init = () => {
  //Vars
  const checklistTemplate = document.querySelector('.page-template-template-checklist');
  let checklistInput =  document.querySelectorAll('.Checklist-input');
  let checklistArrayData = [];

  if (checklistTemplate) {
      checkInputsAndStorage();
      saveList();
  }

  function saveList(){
      checklistInput.forEach(c => {
          c.addEventListener('change', function(){
              checklistArrayData = [];
              localStorage.removeItem('checklist');
              checkInputsAndStorage();
          });
      });
  }

  function checkInputsAndStorage(){
      checklistInput.forEach(input => {
          checklistArrayData.push({id: input.id, checked: input.checked});
      });

      localStorage.setItem('checklist', JSON.stringify(checklistArrayData));
  }
};

// Init on initial page load
init();
